export default __webpack_public_path__ + "static/media/sin-direccion.b6cfb12d.jpg";